import React, { Component } from "react"
import { FormControl } from "react-bootstrap"
import * as ReactQuill from "react-quill-v2.0"
import Select from "react-select"
import moment from "moment"
import DatePicker from "../../../../../../components/common/DatePicker"
import EditReviewTypes from "../ReviewTypes/EditReviewTypes"
import ReviewsReferenceTypes from "../../Reviews/ReviewsTypes/ReviewsReferenceTypes"
import PayAdjuster from "./PayAdjuster/PayAdjuster"
import ExpandedRichText from "../../../../HRUtilities/ExpandedRichText/ExpandedRichText"
import ReviewChecklist from "./ReviewChecklist/ReviewChecklist"
import AxiosConfig from "../../../../../../utilities/AxiosConfig"
import axios from "axios"
import ReviewApproval from "./ReviewApproval/ReviewApproval"
import ReviewApprovalTypes from "../ReviewTypes/ReviewApprovalTypes"
import EmployeeDataTypes from "src/pages/hr/Types/EmployeeTypes"
import PayRatePrompt from "./PayRatePrompt/PayRatePrompt"
import { shouldAllowAccess } from "src/utilities/helper"
import "./EditReview.css"
interface EditReviewProps {
    review: EditReviewTypes
    reviewReference: ReviewsReferenceTypes | null
    contextUserId: string | number
    appendParams: Function
    setEventType: Function
    handleChange: Function | any
    handleQuill: Function
    timeFormat: string
    employeeName: string
    submitStatus: { missing: Array<string>, allRequired: boolean }
    manageParentState: Function
    updateStatus: Function
    detailedEmployeeData: EmployeeDataTypes | {}
    readOnly: boolean
    getReviews: Function
    showApprovals: boolean
    addOrUpdateNotification?: Function
    loadingReview: boolean
    upsertVault77Review: () => Promise<number | null>
    // Re-fetches the open review (Review.getReview) so approval/lock state (HRApprovedDateUtc)
    // updates in place after approving, instead of only on close/reopen.
    refreshReview: () => void
}

interface EditReviewState {
    reviewers: Array<{ id: number, text: string }> | []
    approvals: Array<ReviewApprovalTypes> | []
    loading: boolean
    PayRatePrompt: boolean
    isDelegation: boolean
    delegatorEmployeeId: number
}

class EditReview extends Component<EditReviewProps, EditReviewState> {


    quillFormats = ["font", "color", "header", "bold", "italic", "underline", "strike", "blockquote", "list", "bullet", "indent", "link"]

    state = {
        expandedEditor: false,
        reviewers: [],
        approvals: [],
        loading: false,
        PayRatePrompt: false,
        isDelegation: false,
        delegatorEmployeeId: -1
    }

    componentDidMount() {
        this.getReviewers()
        this.getReviewApproval()
    }

    manageState = (keys: Array<{ key: string, value?: any }>) => {
        let state: any = this.state
        for (let i = 0; i < keys.length; i++) {
            if (Object.entries(keys[i]).length > 1) {
                state[keys[i].key] = keys[i].value
            } else {
                state[keys[i].key] = !state[keys[i].key]
            }
        }
        this.setState(state)
    }

    getPlaceholder =(id: number, key: string, useState?: boolean) => {
        //@ts-ignore
        let reference: any = useState ? this.state[key] : this.props.reviewReference[key]
        for (let i = 0; i < reference.length; i++) {
            if (reference[i].id === id) {
                return reference[i].text
            }
        }
        return "..."
    }

    filterReferenceByReferenceID = (key1: string, key2: string) => {
        //@ts-ignore
        const arr = this.props.reviewReference[key1]
        const review = this.props.review
        let reference = []
        for (let i = 0; i < arr.length; i++) {
            //@ts-ignore
            if (arr[i].referenceId === review[key2]) {
                reference.push(arr[i])
            }
        }
        return reference
    }

    getReviewers = () => {
        let id = this.props.review.EmployeeId
        if (id) {
            this.manageState([{ key: "loading", value: true }])
            axios.get(`${process.env.REACT_APP_API_URL}/api/employeereview/getEmployeeReviewers/${id}`, AxiosConfig.configValue("min"))
                .then((res) => {
                    this.manageState([{ key: "reviewers", value: res.data }])
                })
                .catch((err) => {
                    //console.log("error", err);
                    AxiosConfig.handleError(err);
                })
        } else {
            setTimeout(() => {
                this.getReviewers()
            }, 500)
        }
    }

    getReviewApproval = () => {
        let id = this.props.review.EmployeeReviewId
        if (id) {
            this.manageState([{ key: "loading", value: true }])
            axios.get(`${process.env.REACT_APP_API_URL}/api/employeereview/getEmployeeReviewApproval/${id}`, AxiosConfig.configValue("min"))
                .then((res) => {
                    // //console.log("??? reviewApproval", res.data)
                    const approvals: ReviewApprovalTypes[] = res.data
                    this.handleDelegation(this.getFirstNull(approvals))
                    this.manageState([{ key: "approvals", value: approvals }])
                    this.manageState([{ key: "loading", value: false }])
                })
                .catch((err) => {
                    //console.log("error", err);
                    AxiosConfig.handleError(err);
                    this.manageState([{ key: "loading", value: false }])
                })
        } else {
            setTimeout(() => {
                this.getReviewApproval()
            }, 500)
        }
    }

    handleDelegation = (id: number | string) => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/user/AmIDelegate/${id}/2`, AxiosConfig.configValue("min"))
            .then((res) => {
                this.manageState([{ key: "isDelegation", value: res.data }])
                if (res.data === true) {
                    this.manageState([{ key: "delegatorEmployeeId", value: id }])
                }
            })
            .catch((err) => {
                console.log("error", err);
                AxiosConfig.handleError(err);
            })
    }

    getFirstNull = (approvals: ReviewApprovalTypes[]) => {
        for (let i = 0; i < approvals.length; i++) {
            if (!approvals[i].ApprovalDateUTC) {
                return approvals[i].ApproverEmployeeId
            }
        }
        return 0
    }

    approveReview = (id: number, hrApproval: boolean) => {
        let url = "/api/employeereview/approveEmployeeReview/"
        url += `${id}/noComment`
        if (hrApproval) {
            this.manageState([{ key: "loading", value: true }, { key: "PayRatePrompt", value: true }])
        } else {
            axios.get(process.env.REACT_APP_API_URL + url, AxiosConfig.configValue("min"))
                .then((res) => {
                    // //console.log("??? approveReviewResponse", res.data)
                    this.getReviewApproval()
                }).then(() => {
                    if (this.props.addOrUpdateNotification) {
                        this.props.addOrUpdateNotification(true)
                    }
                    this.props.getReviews()
                    // Refresh the open review so approval state (e.g. ManagerApprovedDateUtc) and
                    // any resulting lock update in place, not just on reopen.
                    this.props.refreshReview()
                })
                .catch((err) => {
                    AxiosConfig.handleError(err);
                    this.manageState([{ key: "loading", value: false }])
                })
        }
    }



    render() {

        const review = this.props.review
        const reviewReference = this.props.reviewReference
        const state = this.state
        const props = this.props
        let readOnly = props.readOnly || typeof (review.SubmittedDateUtc) === "string"

        if (shouldAllowAccess("HR:ADMIN") && !props.addOrUpdateNotification) {
            readOnly = false
        } else if (props.addOrUpdateNotification) {
            readOnly = true
        }

        return (
            <div className="EditReview">
                <div className="EditReviewR1">
                    <div className="ReviewField">
                        <div className="ReviewFieldHeader">
                            <div className="ReviewFieldHeaderLeft">
                                <p>Review Date</p>
                                {props.submitStatus.missing.includes("ReviewDate") && <span className="material-icons">priority_high</span>}
                            </div>
                        </div>
                        <div className="ReviewFieldDatePickerWrapper">
                            <DatePicker
                                value={review.ReviewDate || ""}
                                onChange={(date: number) => props.appendParams([{ ReviewDate: moment(date.valueOf()).format().split("T")[0] }])}
                                type="input"
                                useCloseCallback
                                disabled={readOnly}
                            />
                        </div>
                    </div>
                    {state.reviewers.length > 0 && <div className="ReviewField">
                        <div className="ReviewFieldHeader">
                            <div className="ReviewFieldHeaderLeft">
                                <p>Reviewed By</p>
                                {props.submitStatus.missing.includes("ReviewedBy") && <span className="material-icons">priority_high</span>}
                            </div>
                        </div>
                        <div className="ReviewFieldDropdownWrapper">
                            <Select
                                //@ts-ignore
                                value={{ label: this.getPlaceholder(review.ReviewedBy, "reviewers", true) }}
                                //@ts-ignore
                                options={state.reviewers.map((item) => ({ value: item.id, label: item.text }))}
                                onChange={(item: any) => {
                                    props.appendParams([{ ReviewedBy: item.value }])
                                }}
                                isDisabled={readOnly}
                            />
                        </div>
                    </div>}
                    <div className="ReviewField">
                        <div className="ReviewFieldHeader">
                            <div className="ReviewFieldHeaderLeft">
                                <p>Home Profit Center</p>
                                {props.submitStatus.missing.includes("ProfitCenterId") && <span className="material-icons">priority_high</span>}
                            </div>
                        </div>
                        <div className="ReviewFieldDropdownWrapper">
                            <Select
                                //@ts-ignore
                                value={{ label: this.getPlaceholder(review.ProfitCenterId, "profitCenters") }}
                                options={reviewReference?.profitCenters.map((item) => ({ value: item.id, label: item.text }))}
                                onChange={(item: any) => {
                                    props.appendParams([{ ProfitCenterId: item.value }])
                                }}
                                isDisabled={readOnly}
                            />
                        </div>
                    </div>
                    <div className="ReviewField">
                        <div className="ReviewFieldHeader">
                            <div className="ReviewFieldHeaderLeft">
                                <p>Review Score</p>
                                {props.submitStatus.missing.includes("ReviewScore") && <span className="material-icons">priority_high</span>}
                            </div>
                        </div>
                        <div className="ReviewFieldFormControlWrapper">
                            <FormControl onFocus={() => props.setEventType("ReviewScore")}
                                //@ts-ignore
                                placeholder={review.ReviewScore || "[0..5]"}
                                onChange={props.handleChange}
                                value={review.ReviewScore || ""}
                                type={"number"}
                                disabled={readOnly}
                            />
                        </div>
                    </div>
                </div>
                <div className="EditReviewR2">
                    <div className="ReviewField">
                        <div className="ReviewFieldHeader">
                            <div className="ReviewFieldHeaderLeft">
                                <p>Type</p>
                                {props.submitStatus.missing.includes("EmployeeReviewTypeId") && <span className="material-icons">priority_high</span>}
                            </div>
                        </div>
                        <div className="ReviewFieldDropdownWrapper">
                            <Select
                                //@ts-ignore
                                value={{ label: this.getPlaceholder(review.EmployeeReviewTypeId, "employeeReviewTypes") }}
                                options={reviewReference?.employeeReviewTypes.map((item) => ({ value: item.id, label: item.text }))}
                                onChange={(item: any) => {
                                    props.appendParams([{ EmployeeReviewTypeId: item.value }, { EmployeeReviewReasonId: null }])
                                }}
                                isDisabled={readOnly}
                            />
                        </div>
                    </div>
                    <div className="ReviewField">
                        <div className="ReviewFieldHeader">
                            <div className="ReviewFieldHeaderLeft">
                                <p>Reason</p>
                                {props.submitStatus.missing.includes("EmployeeReviewReasonId") && <span className="material-icons">priority_high</span>}
                            </div>
                        </div>
                        <div className="ReviewFieldDropdownWrapper">
                            <Select
                                //@ts-ignore
                                value={{ label: this.getPlaceholder(review.EmployeeReviewReasonId, "employeeReviewReason") }}
                                options={this.filterReferenceByReferenceID("employeeReviewReason", "EmployeeReviewTypeId").map((item) => ({ value: item.id, label: item.text }))}
                                onChange={(item: any) => {
                                    props.appendParams([{ EmployeeReviewReasonId: item.value }])
                                }}
                                isDisabled={readOnly}
                            />
                        </div>
                    </div>
                    <div className="ReviewField">
                        <div className="ReviewFieldHeader">
                            <div className="ReviewFieldHeaderLeft">
                                <p>Current Job Title</p>
                                {props.submitStatus.missing.includes("CurrentJobTitleId") && <span className="material-icons">priority_high</span>}
                            </div>
                        </div>
                        <div className="ReviewFieldFormControlWrapper">
                            <FormControl
                                placeholder={this.getPlaceholder(review.CurrentJobTitleId, "jobTitles")}
                                onChange={props.handleChange}
                                value={this.getPlaceholder(review.CurrentJobTitleId, "jobTitles")}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="ReviewField">
                        <div className="ReviewFieldHeader">
                            <div className="ReviewFieldHeaderLeft">
                                <p>Change Title to</p>
                                {props.submitStatus.missing.includes("NewJobTitleId") && <span className="material-icons">priority_high</span>}
                            </div>
                        </div>
                        <div className="ReviewFieldDropdownWrapper">
                            <Select
                                placeholder={this.getPlaceholder(review.NewJobTitleId, "jobTitles")}
                                //@ts-ignore
                                value={{ label: this.getPlaceholder(review.NewJobTitleId, "jobTitles") }}
                                options={reviewReference?.jobTitles.map((item) => ({ value: item.id, label: item.text }))}
                                onChange={(item: any) => {
                                    props.appendParams([{ NewJobTitleId: item.value }])
                                }}
                                isDisabled={readOnly}
                                maxMenuHeight={150}
                            />
                        </div>
                    </div>
                </div>
                {props.review.EmployeeReviewId && <div className="EditReviewR3">
                    <PayAdjuster
                        manageParentState={props.manageParentState}
                        reviewId={props.review.EmployeeReviewId}
                        employeeId={props.review.EmployeeId}
                        //@ts-ignore
                        userId={props.detailedEmployeeData.UserId}
                        readOnly={readOnly || typeof(props.review.HRApprovedDateUtc) === "string"}
                        approved={typeof (props.review.HRApprovedDateUtc) === "string"}
                    />
                </div>}
                <div className="EditReviewR4">
                    <div className="EditReviewR4C1">
                        <div className="EditReviewR4C1Header">
                            <div className="EditReviewR4C1HeaderLeft">
                                <span className="material-icons">comment</span>
                                <p>Comments</p>
                            </div>
                            <div className="EditReviewR4C1HeaderRight">
                                <span className="material-icons" onClick={() => this.manageState([{ key: "expandedEditor" }])}>open_in_full</span>
                            </div>
                        </div>
                        {/*@ts-ignore*/}
                        {!this.state.expandedEditor && <ReactQuill
                            value={review.Comments}
                            onFocus={() => props.setEventType("Comments")}
                            onChange={props.handleQuill}
                            formats={this.quillFormats}
                            readOnly={readOnly}
                        />}
                        {this.state.expandedEditor && <ExpandedRichText
                            type="Review Comments"
                            eventKey=""
                            toggleKey="expandedEditor"
                            text={review.Comments}
                            setEventType={() => props.setEventType("Comments")}
                            handleQuill={props.handleQuill}
                            toggleEditor={() => this.manageState([{ key: "expandedEditor" }])}
                            dirty={true}
                            readOnly={readOnly}
                        />}
                    </div>
                    {props.showApprovals && <div className="EditReviewR4C2">
                        <ReviewApproval
                            approvals={this.state.approvals}
                            approveReview={this.approveReview}
                            contextUserId={this.props.contextUserId}
                            review={props.review}
                            loading={this.state.loading || this.props.loadingReview}
                            readOnly={readOnly}
                            isDelegation={this.state.isDelegation}
                            delegatorEmployeeId={this.state.delegatorEmployeeId}
                        />
                    </div>}
                    <div className="EditReviewR4C3">
                        <ReviewChecklist
                            reviewerId={props.contextUserId}
                            //@ts-ignore
                            EmployeeReviewId={review.EmployeeReviewId}
                            employeeName={props.employeeName}
                            readOnly={readOnly}
                        />
                    </div>
                </div>
                {state.PayRatePrompt && <PayRatePrompt
                    reviewId={props.review.EmployeeReviewId}
                    employeeId={props.review.EmployeeId}
                    manageParentState={this.manageState}
                    upsertVault77Review={props.upsertVault77Review}
                    getReviewApproval={this.getReviewApproval}
                    addOrUpdateNotification={props.addOrUpdateNotification}
                    getReviews={props.getReviews}
                    approveReview={this.approveReview}
                    refreshReview={props.refreshReview}
                />}
            </div>
        )
    }
}

export default EditReview